import { VStack, Link } from '@chakra-ui/layout'
import { Modal, ModalOverlay, ModalContent, ModalBody, Text } from '@chakra-ui/react'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ROUTES } from '../contants'

type Props = {
  isOpen: boolean
  onClose: () => void
  message?: string
  error?: boolean
  action?: string
  link?: string
}
const ActionModal = ({ isOpen, onClose, message, error, action, link }: Props) => {
  return (
    <Modal
      closeOnOverlayClick={message?.includes('PIN already exists') ? false : !!error}
      isOpen={isOpen}
      onClose={onClose}
      isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.8)" />
      <ModalContent>
        <ModalBody bg="white" pt="3.4rem" as={VStack} textAlign="center">
          {error ? (
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M39.84 6.25L53.75 20.1675V39.8425L39.84 53.75H20.165L6.25 39.84V20.165L20.165 6.25H39.84ZM37.7675 11.25H22.235L11.2525 22.2375V37.77L22.235 48.755H37.7675L48.7525 37.77V22.235L37.7675 11.2525V11.25ZM27.5 37.5H32.5V42.5H27.5V37.5ZM27.5 17.5H32.5V32.5H27.5V17.5Z"
                fill="#FF1B1B"
              />
            </svg>
          ) : (
            <svg
              width="46"
              height="56"
              viewBox="0 0 46 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23 0.5L43.5425 5.065C44.685 5.32 45.5 6.3325 45.5 7.505V32.4725C45.5 37.4875 42.9925 42.1725 38.82 44.9525L23 55.5L7.18 44.9525C3.005 42.17 0.5 37.4875 0.5 32.475V7.505C0.5 6.3325 1.315 5.32 2.4575 5.065L23 0.5ZM23 5.6225L5.5 9.51V32.4725C5.5 35.815 7.17 38.9375 9.9525 40.7925L23 49.4925L36.0475 40.7925C38.83 38.9375 40.5 35.8175 40.5 32.475V9.51L23 5.625V5.6225ZM34.13 18.555L37.6675 22.09L21.7575 38L11.15 27.3925L14.685 23.8575L21.755 30.9275L34.13 18.5525V18.555Z"
                fill="#0AB86F"
              />
            </svg>
          )}
          <Text my="1.5rem !important">
            {(error && message) ||
              message ||
              'An email has been sent to you to activate your account'}
          </Text>

          {link ? (
            <Link
              fontWeight="500"
              as={RouterLink}
              d="block"
              to={link}
              mt="1rem !important"
              mb="1rem !important"
              _hover={{ border: 'none', outline: 'none' }}
              _active={{ border: 'none', outline: 'none' }}
              _focus={{ border: 'none', outline: 'none' }}
              color="brand.blue">
              {action}
            </Link>
          ) : action ? (
            <Text
              fontWeight="500"
              d="block"
              onClick={onClose}
              cursor="pointer"
              mt="1rem !important"
              mb="1rem !important"
              _hover={{ border: 'none', outline: 'none' }}
              _active={{ border: 'none', outline: 'none' }}
              _focus={{ border: 'none', outline: 'none' }}
              color="brand.blue">
              {action}
            </Text>
          ) : (
            <Link
              fontWeight="500"
              as={RouterLink}
              d="block"
              onClick={onClose}
              to={action ? ROUTES.resetPin : ROUTES.login}
              mt="1rem !important"
              mb="1rem !important"
              _hover={{ border: 'none', outline: 'none' }}
              _active={{ border: 'none', outline: 'none' }}
              _focus={{ border: 'none', outline: 'none' }}
              color="brand.blue">
              Login
            </Link>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export { ActionModal }
